import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AppDownloadBanner',
  setup(__props) {

// isDesktop はグローバル mixin（src/main.js=true, src_sp/main.js=false）を
// テンプレートで直接参照する（CompleteStepper.vue と同様のパターン）。
// 表示条件（isNative/A-Bテスト判定）は呼び出し元が制御するため、本コンポーネントは
// props/emitを持たない静的コンテンツのみ（design.md「アプリダウンロードバナー共通化設計」）。
// 呼び出し元（ApplicationComplete.vue／ApplicationHotelComplete.vue）は現状どおりSP限定で
// マウントするため、isDesktop分岐のPC側パスは実運用では到達しない（Histoireのプレビュー用途のみ）。
// SP実測値はFigma node 6298:59066（PC node 6298:60989 と対応）。ポイント提携先ロゴ・
// ストアバッジの並び順（App Store→Google Play）はSP側のみFigmaに一致させた。

// 既存のSP専用インラインmarkup（ApplicationComplete.vue）と同一のストアリンクURL・バッジ画像を流用。
const storeUrl = 'https://travelist.onelink.me/VSoR/f2ut355z';

// アイコンは要件7.4の3訴求（一次ソースはrequirements.md）。文言はFigma node 6298:60989 と
// 一致するが、3つ目のみFigmaのモックアップ表記「¥500OFF！」・requirements.mdの表記
// 「次回のご予約が¥500OFFになる」のいずれとも異なる（要確認、要件確認が取れるまでは
// 現状の文言を維持する）。
const appeals = [
  { icon: 'fa-solid fa-rotate', text: '貯めたポイントを他社ポイントに交換' },
  { icon: 'fa-solid fa-user', text: 'マイページで予約の確認が簡単' },
  { icon: 'fa-solid fa-tag', text: '次回予約で使える500円OFFクーポン' },
];

return { __sfc: true,storeUrl, appeals }
}

})